import { useConfiguration } from '@travel-frontend/core';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWishlistIdentifier } from '../../../../components/Wishlist/hooks/useWishlistIdentifier/useWishlistIdentifier.js';
import { addToWishlist as addToWishlistAction, removeFromWishlist as removeFromWishlistAction } from '../../../../components/Wishlist/redux/wishlist-meta/actions.js';
import { wishlistMetaState as selectWishlistMeta } from '../../../../components/Wishlist/redux/wishlist-meta/WishlistMetaState.js';
export const useWishlistMutation = () => {
  const dispatch = useDispatch();
  const url = useConfiguration('wishlistBaseUrl');
  const {
    id,
    type
  } = useWishlistIdentifier();
  const {
    data
  } = useSelector(selectWishlistMeta);
  const addToWishlist = useCallback((hotelId, options = {}) => {
    if (!url) throw new Error('wishlistBaseUrl is not defined in ConfigurationProvider');
    if (!id || !type || !data?.defaultListID) return;
    dispatch(
    // @ts-expect-error fixme
    addToWishlistAction({
      url,
      identifierId: id,
      identifierType: type,
      listId: data?.defaultListID,
      hotelId,
      onSuccess: options.onSuccess,
      onError: options.onError
    }));
  }, [data?.defaultListID, dispatch, id, type, url]);
  const removeFromWishlist = useCallback((hotelId, options = {}) => {
    if (!url) throw new Error('wishlistBaseUrl is not defined in ConfigurationProvider');
    if (!id || !type || !data?.defaultListID) return;
    dispatch(
    // @ts-expect-error fixme
    removeFromWishlistAction({
      url,
      identifierId: id,
      identifierType: type,
      listId: data?.defaultListID,
      hotelId,
      onSuccess: options.onSuccess,
      onError: options.onError
    }));
  }, [data?.defaultListID, dispatch, id, type, url]);
  return {
    addToWishlist,
    removeFromWishlist
  };
};